import { Card, EmptyState, Page } from "@shopify/polaris";

export const Empty = () => {
  return (
    <Page>
      <Card sectioned>
        <EmptyState
          heading="Search Experience Preview"
          secondaryAction={{ content: "Learn more", url: "https://reactify.com.au/tools/search" }}
          image="https://reactify.com.au/images/logo-icon.svg"
        >
          <p>Start the preview from within your store using the app.</p>
        </EmptyState>
      </Card>
    </Page>
  );
};
